import { canAccessAdmin } from './permissions';

export const getLoginRedirectPath = (user) => {
  if (canAccessAdmin(user)) {
    return '/admin';
  }
  if (user?.companyID) {
    return `/company/${user.companyID}`;
  }
  return '/';
};

export const isAdminPort = (port = window.location.port) =>
  port === '18083' || port === '18085';

export const shouldRedirectCompanyRoute = (user, routeCompanyID) => {
  if (canAccessAdmin(user)) {
    return false;
  }
  return !!user?.companyID && !!routeCompanyID && user.companyID !== routeCompanyID;
};
